"use client";

import { usePathname, redirect } from "next/navigation";
import { defaultLocale } from "@/i18n/settings";

export default function RootNotFound() {
  const pathname = usePathname();
  const currentLocale = pathname.split("/")[1] || defaultLocale;

  redirect(`/${currentLocale}/not-found`);
}
